import { Trans } from "@lingui/react/macro";
import { cloneDeep } from "lodash";
import { observable } from "mobx";
import { useState } from "react";

import { Button } from "../../../components/ui-kit/button";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "../../../components/ui-kit/dialog";
import { createPatch } from "../../../utils/patch";
import { AdminConsole } from "../admin-console";
import { QuestionnaireSettingsItem } from "./questionnaire-settings";
import { QuestionnaireSettingsForm } from "./questionnaire-settings-form";

export function EditQuestionnaireSettingsDialog({
  item,
  admin,
  onClose,
  onSave,
}: {
  item: QuestionnaireSettingsItem;
  admin: AdminConsole;
  onClose: () => void;
  onSave: (patch: Record<string, unknown>) => Promise<void>;
}) {
  const [fields] = useState(() =>
    observable({
      first_when_active: item.first_when_active,
      skippable: item.skippable ?? false,
      filling_frequency: cloneDeep(item.filling_frequency ?? []),
      first_after_active: cloneDeep(item.first_after_active) ?? null,
      stop_after_n: item.stop_after_n ?? null,
      stop_after_time_from_first:
        cloneDeep(item.stop_after_time_from_first) ?? null,
    }),
  );

  async function save() {
    const body = createPatch(fields, item);
    if (Object.keys(body).length === 0) {
      onClose();
      return;
    }
    await onSave(body);
    onClose();
  }

  return (
    <Dialog open onOpenChange={() => onClose()} width="672px">
      <DialogHeader>
        <Trans>Edit questionnaire settings</Trans>
      </DialogHeader>
      <DialogBody>
        <QuestionnaireSettingsForm fields={fields} admin={admin} mode="edit" />
      </DialogBody>
      <DialogFooter>
        <Button onClick={onClose}>
          <Trans>Cancel</Trans>
        </Button>
        <Button variant="primary" onClick={() => save()}>
          <Trans>Save</Trans>
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
